var React = require('react');

function Date (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#1d1d1b;}")),React.createElement("path",{"d":"M8.23,1.03h-1.41V0h-1.42V1.03h-1.95V0h-1.42V1.03H.62c-.34,0-.62,.3-.62,.67v6.93l.45,.57h7.94l.45-.57V1.7c0-.37-.28-.67-.62-.67Zm-.77,7.26c0,.15-.12,.28-.28,.28H1.67c-.15,0-.28-.12-.28-.28V3.31c0-.1,.08-.17,.17-.17h.46v1.11h1.42v-1.11h1.95v1.11h1.42v-1.11h.46c.1,0,.17,.08,.17,.17v4.99Z","key":1})]);
}

Date.defaultProps = {"id":"Ebene_1","viewBox":"0 0 8.85 9.21"};

module.exports = Date;

Date.default = Date;
